import b from "react";
import { jsx as Rr } from "../../../_virtual/jsx-runtime.js";
var ge = (e) => e.type === "checkbox", ne = (e) => e instanceof Date, B = (e) => e == null;
const nr = (e) => typeof e == "object";
var T = (e) => !B(e) && !Array.isArray(e) && nr(e) && !ne(e), ar = (e) => T(e) && e.target ? ge(e.target) ? e.target.checked : e.target.value : e, Lr = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, lr = (e, i) => e.has(Lr(i)), Tr = (e) => {
  const i = e.constructor && e.constructor.prototype;
  return T(i) && i.hasOwnProperty("isPrototypeOf");
}, We = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function P(e) {
  let i;
  const r = Array.isArray(e);
  if (e instanceof Date)
    i = new Date(e);
  else if (e instanceof Set)
    i = new Set(e);
  else if (!(We && (e instanceof Blob || e instanceof FileList)) && (r || T(e)))
    if (i = r ? [] : {}, !Array.isArray(e) && !Tr(e))
      i = e;
    else
      for (const t in e)
        i[t] = P(e[t]);
  else
    return e;
  return i;
}
var le = (e) => Array.isArray(e) ? e.filter(Boolean) : [], D = (e) => e === void 0, c = (e, i, r) => {
  if (!i || !T(e))
    return r;
  const t = le(i.split(/[,[\].]+?/)).reduce((u, l) => B(u) ? u : u[l], e);
  return D(t) || t === e ? D(e[i]) ? r : e[i] : t;
};
const he = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, K = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Y = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, or = b.createContext(null), Fe = () => b.useContext(or), Xr = (e) => {
  const {
    children: i,
    ...r
  } = e;
  return /* @__PURE__ */ Rr(or.Provider, {
    value: r,
    children: i
  });
};
var cr = (e, i, r, t = !0) => {
  const u = {
    defaultValues: i._defaultValues
  };
  for (const l in e)
    Object.defineProperty(u, l, {
      get: () => {
        const f = l;
        return i._proxyFormState[f] !== K.all && (i._proxyFormState[f] = !t || K.all), r && (r[f] = !0), e[f];
      }
    });
  return u;
}, W = (e) => T(e) && !Object.keys(e).length, fr = (e, i, r, t) => {
  r(e);
  const {
    name: u,
    ...l
  } = e;
  return W(l) || Object.keys(l).length >= Object.keys(i).length || Object.keys(l).find((f) => i[f] === (!t || K.all));
}, $ = (e) => Array.isArray(e) ? e : [e], dr = (e, i, r) => r && i ? e === i : !e || !i || e === i || $(e).some((t) => t && (t.startsWith(i) || i.startsWith(t)));
function xe(e) {
  const i = b.useRef(e);
  i.current = e, b.useEffect(() => {
    const r = !e.disabled && i.current.subject && i.current.subject.subscribe({
      next: i.current.next
    });
    return () => {
      r && r.unsubscribe();
    };
  }, [e.disabled]);
}
function Ur(e) {
  const i = Fe(), {
    control: r = i.control,
    disabled: t,
    name: u,
    exact: l
  } = e || {}, [f, A] = b.useState(r._formState), _ = b.useRef(!0), S = b.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), E = b.useRef(u);
  return E.current = u, xe({
    disabled: t,
    next: (F) => _.current && dr(E.current, F.name, l) && fr(F, S.current, r._updateFormState) && A({
      ...r._formState,
      ...F
    }),
    subject: r._subjects.state
  }), b.useEffect(() => {
    _.current = !0;
    const F = r._proxyFormState.isDirty && r._getDirty();
    return F !== r._formState.isDirty && r._subjects.state.next({
      isDirty: F
    }), S.current.isValid && r._updateValid(!0), () => {
      _.current = !1;
    };
  }, [r]), cr(f, r, S.current, !1);
}
var Q = (e) => typeof e == "string", yr = (e, i, r, t, u) => Q(e) ? (t && i.watch.add(e), c(r, e, u)) : Array.isArray(e) ? e.map((l) => (t && i.watch.add(l), c(r, l))) : (t && (i.watchAll = !0), r);
function Mr(e) {
  const i = Fe(), {
    control: r = i.control,
    name: t,
    defaultValue: u,
    disabled: l,
    exact: f
  } = e || {}, A = b.useRef(t);
  A.current = t, xe({
    disabled: l,
    subject: r._subjects.values,
    next: (E) => {
      dr(A.current, E.name, f) && S(P(yr(A.current, r._names, E.values || r._formValues, !1, u)));
    }
  });
  const [_, S] = b.useState(r._getWatch(t, u));
  return b.useEffect(() => r._removeUnmounted()), _;
}
var $e = (e) => /^\w*$/.test(e), gr = (e) => le(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function k(e, i, r) {
  let t = -1;
  const u = $e(i) ? [i] : gr(i), l = u.length, f = l - 1;
  for (; ++t < l; ) {
    const A = u[t];
    let _ = r;
    if (t !== f) {
      const S = e[A];
      _ = T(S) || Array.isArray(S) ? S : isNaN(+u[t + 1]) ? {} : [];
    }
    e[A] = _, e = e[A];
  }
  return e;
}
function Br(e) {
  const i = Fe(), {
    name: r,
    control: t = i.control,
    shouldUnregister: u
  } = e, l = lr(t._names.array, r), f = Mr({
    control: t,
    name: r,
    defaultValue: c(t._formValues, r, c(t._defaultValues, r, e.defaultValue)),
    exact: !0
  }), A = Ur({
    control: t,
    name: r
  }), _ = b.useRef(t.register(r, {
    ...e.rules,
    value: f
  }));
  return b.useEffect(() => {
    const S = t._options.shouldUnregister || u, E = (F, v) => {
      const j = c(t._fields, F);
      j && (j._f.mount = v);
    };
    if (E(r, !0), S) {
      const F = P(c(t._options.defaultValues, r));
      k(t._defaultValues, r, F), D(c(t._formValues, r)) && k(t._formValues, r, F);
    }
    return () => {
      (l ? S && !t._state.action : S) ? t.unregister(r) : E(r, !1);
    };
  }, [r, t, l, u]), {
    field: {
      name: r,
      value: f,
      onChange: b.useCallback((S) => _.current.onChange({
        target: {
          value: ar(S),
          name: r
        },
        type: he.CHANGE
      }), [r]),
      onBlur: b.useCallback(() => _.current.onBlur({
        target: {
          value: c(t._formValues, r),
          name: r
        },
        type: he.BLUR
      }), [r, t]),
      ref: (S) => {
        const E = c(t._fields, r);
        E && S && (E._f.ref = {
          focus: () => S.focus(),
          select: () => S.select(),
          setCustomValidity: (F) => S.setCustomValidity(F),
          reportValidity: () => S.reportValidity()
        });
      }
    },
    formState: A,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!c(A.errors, r)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!c(A.dirtyFields, r)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!c(A.touchedFields, r)
      },
      error: {
        enumerable: !0,
        get: () => c(A.errors, r)
      }
    })
  };
}
const Yr = (e) => e.render(Br(e));
var Nr = (e, i, r, t, u) => i ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [t]: u || !0
  }
} : {};
const ve = (e, i, r) => {
  for (const t of r || Object.keys(e)) {
    const u = c(e, t);
    if (u) {
      const {
        _f: l,
        ...f
      } = u;
      if (l && i(l.name)) {
        if (l.ref.focus) {
          l.ref.focus();
          break;
        } else if (l.refs && l.refs[0].focus) {
          l.refs[0].focus();
          break;
        }
      } else
        T(f) && ve(f, i);
    }
  }
};
var Z = () => {
  const e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (i) => {
    const r = (Math.random() * 16 + e) % 16 | 0;
    return (i == "x" ? r : r & 3 | 8).toString(16);
  });
}, De = (e, i, r = {}) => r.shouldFocus || D(r.shouldFocus) ? r.focusName || `${e}.${D(r.focusIndex) ? i : r.focusIndex}.` : "", Pe = (e) => ({
  isOnSubmit: !e || e === K.onSubmit,
  isOnBlur: e === K.onBlur,
  isOnChange: e === K.onChange,
  isOnAll: e === K.all,
  isOnTouch: e === K.onTouched
}), je = (e, i, r) => !r && (i.watchAll || i.watch.has(e) || [...i.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), _r = (e, i, r) => {
  const t = le(c(e, r));
  return k(t, "root", i[r]), k(e, r, t), e;
}, ae = (e) => typeof e == "boolean", He = (e) => e.type === "file", ee = (e) => typeof e == "function", Ae = (e) => {
  if (!We)
    return !1;
  const i = e ? e.ownerDocument : 0;
  return e instanceof (i && i.defaultView ? i.defaultView.HTMLElement : HTMLElement);
}, _e = (e) => Q(e), Ke = (e) => e.type === "radio", me = (e) => e instanceof RegExp;
const er = {
  value: !1,
  isValid: !1
}, rr = {
  value: !0,
  isValid: !0
};
var hr = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const i = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return {
        value: i,
        isValid: !!i.length
      };
    }
    return e[0].checked && !e[0].disabled ? e[0].attributes && !D(e[0].attributes.value) ? D(e[0].value) || e[0].value === "" ? rr : {
      value: e[0].value,
      isValid: !0
    } : rr : er;
  }
  return er;
};
const tr = {
  isValid: !1,
  value: null
};
var vr = (e) => Array.isArray(e) ? e.reduce((i, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : i, tr) : tr;
function sr(e, i, r = "validate") {
  if (_e(e) || Array.isArray(e) && e.every(_e) || ae(e) && !e)
    return {
      type: r,
      message: _e(e) ? e : "",
      ref: i
    };
}
var ue = (e) => T(e) && !me(e) ? e : {
  value: e,
  message: ""
}, qe = async (e, i, r, t, u) => {
  const {
    ref: l,
    refs: f,
    required: A,
    maxLength: _,
    minLength: S,
    min: E,
    max: F,
    pattern: v,
    validate: j,
    name: N,
    valueAsNumber: oe,
    mount: se,
    disabled: ce
  } = e._f, V = c(i, N);
  if (!se || ce)
    return {};
  const q = f ? f[0] : l, G = (w) => {
    t && q.reportValidity && (q.setCustomValidity(ae(w) ? "" : w || ""), q.reportValidity());
  }, y = {}, m = Ke(l), x = ge(l), L = m || x, M = (oe || He(l)) && D(l.value) && D(V) || Ae(l) && l.value === "" || V === "" || Array.isArray(V) && !V.length, z = Nr.bind(null, N, r, y), X = (w, p, O, I = Y.maxLength, H = Y.minLength) => {
    const J = w ? p : O;
    y[N] = {
      type: w ? I : H,
      message: J,
      ref: l,
      ...z(w ? I : H, J)
    };
  };
  if (u ? !Array.isArray(V) || !V.length : A && (!L && (M || B(V)) || ae(V) && !V || x && !hr(f).isValid || m && !vr(f).isValid)) {
    const {
      value: w,
      message: p
    } = _e(A) ? {
      value: !!A,
      message: A
    } : ue(A);
    if (w && (y[N] = {
      type: Y.required,
      message: p,
      ref: q,
      ...z(Y.required, p)
    }, !r))
      return G(p), y;
  }
  if (!M && (!B(E) || !B(F))) {
    let w, p;
    const O = ue(F), I = ue(E);
    if (!B(V) && !isNaN(V)) {
      const H = l.valueAsNumber || V && +V;
      B(O.value) || (w = H > O.value), B(I.value) || (p = H < I.value);
    } else {
      const H = l.valueAsDate || new Date(V), J = (de) => new Date(new Date().toDateString() + " " + de), re = l.type == "time", fe = l.type == "week";
      Q(O.value) && V && (w = re ? J(V) > J(O.value) : fe ? V > O.value : H > new Date(O.value)), Q(I.value) && V && (p = re ? J(V) < J(I.value) : fe ? V < I.value : H < new Date(I.value));
    }
    if ((w || p) && (X(!!w, O.message, I.message, Y.max, Y.min), !r))
      return G(y[N].message), y;
  }
  if ((_ || S) && !M && (Q(V) || u && Array.isArray(V))) {
    const w = ue(_), p = ue(S), O = !B(w.value) && V.length > +w.value, I = !B(p.value) && V.length < +p.value;
    if ((O || I) && (X(O, w.message, p.message), !r))
      return G(y[N].message), y;
  }
  if (v && !M && Q(V)) {
    const {
      value: w,
      message: p
    } = ue(v);
    if (me(w) && !V.match(w) && (y[N] = {
      type: Y.pattern,
      message: p,
      ref: l,
      ...z(Y.pattern, p)
    }, !r))
      return G(p), y;
  }
  if (j) {
    if (ee(j)) {
      const w = await j(V, i), p = sr(w, q);
      if (p && (y[N] = {
        ...p,
        ...z(Y.validate, p.message)
      }, !r))
        return G(p.message), y;
    } else if (T(j)) {
      let w = {};
      for (const p in j) {
        if (!W(w) && !r)
          break;
        const O = sr(await j[p](V, i), q, p);
        O && (w = {
          ...O,
          ...z(p, O.message)
        }, G(O.message), r && (y[N] = w));
      }
      if (!W(w) && (y[N] = {
        ref: q,
        ...w
      }, !r))
        return y;
    }
  }
  return G(!0), y;
};
function Ee(e, i) {
  return [...e, ...$(i)];
}
var Ce = (e) => Array.isArray(e) ? e.map(() => {
}) : void 0;
function Oe(e, i, r) {
  return [...e.slice(0, i), ...$(r), ...e.slice(i)];
}
var Re = (e, i, r) => Array.isArray(e) ? (D(e[r]) && (e[r] = void 0), e.splice(r, 0, e.splice(i, 1)[0]), e) : [];
function Le(e, i) {
  return [...$(i), ...$(e)];
}
function Ir(e, i) {
  let r = 0;
  const t = [...e];
  for (const u of i)
    t.splice(u - r, 1), r++;
  return le(t).length ? t : [];
}
var Te = (e, i) => D(i) ? [] : Ir(e, $(i).sort((r, t) => r - t)), Ue = (e, i, r) => {
  e[i] = [e[r], e[r] = e[i]][0];
};
function Pr(e, i) {
  const r = i.slice(0, -1).length;
  let t = 0;
  for (; t < r; )
    e = D(e) ? t++ : e[i[t++]];
  return e;
}
function jr(e) {
  for (const i in e)
    if (!D(e[i]))
      return !1;
  return !0;
}
function U(e, i) {
  const r = Array.isArray(i) ? i : $e(i) ? [i] : gr(i), t = r.length === 1 ? e : Pr(e, r), u = r.length - 1, l = r[u];
  return t && delete t[l], u !== 0 && (T(t) && W(t) || Array.isArray(t) && jr(t)) && U(e, r.slice(0, -1)), e;
}
var ir = (e, i, r) => (e[i] = r, e);
function Zr(e) {
  const i = Fe(), {
    control: r = i.control,
    name: t,
    keyName: u = "id",
    shouldUnregister: l
  } = e, [f, A] = b.useState(r._getFieldArray(t)), _ = b.useRef(r._getFieldArray(t).map(Z)), S = b.useRef(f), E = b.useRef(t), F = b.useRef(!1);
  E.current = t, S.current = f, r._names.array.add(t), e.rules && r.register(t, e.rules), xe({
    next: ({
      values: y,
      name: m
    }) => {
      if (m === E.current || !m) {
        const x = c(y, E.current);
        Array.isArray(x) && (A(x), _.current = x.map(Z));
      }
    },
    subject: r._subjects.array
  });
  const v = b.useCallback((y) => {
    F.current = !0, r._updateFieldArray(t, y);
  }, [r, t]), j = (y, m) => {
    const x = $(P(y)), L = Ee(r._getFieldArray(t), x);
    r._names.focus = De(t, L.length - 1, m), _.current = Ee(_.current, x.map(Z)), v(L), A(L), r._updateFieldArray(t, L, Ee, {
      argA: Ce(y)
    });
  }, N = (y, m) => {
    const x = $(P(y)), L = Le(r._getFieldArray(t), x);
    r._names.focus = De(t, 0, m), _.current = Le(_.current, x.map(Z)), v(L), A(L), r._updateFieldArray(t, L, Le, {
      argA: Ce(y)
    });
  }, oe = (y) => {
    const m = Te(r._getFieldArray(t), y);
    _.current = Te(_.current, y), v(m), A(m), r._updateFieldArray(t, m, Te, {
      argA: y
    });
  }, se = (y, m, x) => {
    const L = $(P(m)), M = Oe(r._getFieldArray(t), y, L);
    r._names.focus = De(t, y, x), _.current = Oe(_.current, y, L.map(Z)), v(M), A(M), r._updateFieldArray(t, M, Oe, {
      argA: y,
      argB: Ce(m)
    });
  }, ce = (y, m) => {
    const x = r._getFieldArray(t);
    Ue(x, y, m), Ue(_.current, y, m), v(x), A(x), r._updateFieldArray(t, x, Ue, {
      argA: y,
      argB: m
    }, !1);
  }, V = (y, m) => {
    const x = r._getFieldArray(t);
    Re(x, y, m), Re(_.current, y, m), v(x), A(x), r._updateFieldArray(t, x, Re, {
      argA: y,
      argB: m
    }, !1);
  }, q = (y, m) => {
    const x = P(m), L = ir(r._getFieldArray(t), y, x);
    _.current = [...L].map((M, z) => !M || z === y ? Z() : _.current[z]), v(L), A([...L]), r._updateFieldArray(t, L, ir, {
      argA: y,
      argB: x
    }, !0, !1);
  }, G = (y) => {
    const m = $(P(y));
    _.current = m.map(Z), v([...m]), A([...m]), r._updateFieldArray(t, [...m], (x) => x, {}, !0, !1);
  };
  return b.useEffect(() => {
    if (r._state.action = !1, je(t, r._names) && r._subjects.state.next({
      ...r._formState
    }), F.current && (!Pe(r._options.mode).isOnSubmit || r._formState.isSubmitted))
      if (r._options.resolver)
        r._executeSchema([t]).then((y) => {
          const m = c(y.errors, t), x = c(r._formState.errors, t);
          (x ? !m && x.type : m && m.type) && (m ? k(r._formState.errors, t, m) : U(r._formState.errors, t), r._subjects.state.next({
            errors: r._formState.errors
          }));
        });
      else {
        const y = c(r._fields, t);
        y && y._f && qe(y, r._formValues, r._options.criteriaMode === K.all, r._options.shouldUseNativeValidation, !0).then((m) => !W(m) && r._subjects.state.next({
          errors: _r(r._formState.errors, m, t)
        }));
      }
    r._subjects.values.next({
      name: t,
      values: {
        ...r._formValues
      }
    }), r._names.focus && ve(r._fields, (y) => !!y && y.startsWith(r._names.focus || "")), r._names.focus = "", r._updateValid();
  }, [f, t, r]), b.useEffect(() => (!c(r._formValues, t) && r._updateFieldArray(t), () => {
    (r._options.shouldUnregister || l) && r.unregister(t);
  }), [t, r, u, l]), {
    swap: b.useCallback(ce, [v, t, r]),
    move: b.useCallback(V, [v, t, r]),
    prepend: b.useCallback(N, [v, t, r]),
    append: b.useCallback(j, [v, t, r]),
    remove: b.useCallback(oe, [v, t, r]),
    insert: b.useCallback(se, [v, t, r]),
    update: b.useCallback(q, [v, t, r]),
    replace: b.useCallback(G, [v, t, r]),
    fields: b.useMemo(() => f.map((y, m) => ({
      ...y,
      [u]: _.current[m] || Z()
    })), [f, u])
  };
}
function Me() {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (u) => {
      for (const l of e)
        l.next && l.next(u);
    },
    subscribe: (u) => (e.push(u), {
      unsubscribe: () => {
        e = e.filter((l) => l !== u);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}
var Ve = (e) => B(e) || !nr(e);
function te(e, i) {
  if (Ve(e) || Ve(i))
    return e === i;
  if (ne(e) && ne(i))
    return e.getTime() === i.getTime();
  const r = Object.keys(e), t = Object.keys(i);
  if (r.length !== t.length)
    return !1;
  for (const u of r) {
    const l = e[u];
    if (!t.includes(u))
      return !1;
    if (u !== "ref") {
      const f = i[u];
      if (ne(l) && ne(f) || T(l) && T(f) || Array.isArray(l) && Array.isArray(f) ? !te(l, f) : l !== f)
        return !1;
    }
  }
  return !0;
}
var Ar = (e) => e.type === "select-multiple", qr = (e) => Ke(e) || ge(e), Be = (e) => Ae(e) && e.isConnected, mr = (e) => {
  for (const i in e)
    if (ee(e[i]))
      return !0;
  return !1;
};
function be(e, i = {}) {
  const r = Array.isArray(e);
  if (T(e) || r)
    for (const t in e)
      Array.isArray(e[t]) || T(e[t]) && !mr(e[t]) ? (i[t] = Array.isArray(e[t]) ? [] : {}, be(e[t], i[t])) : B(e[t]) || (i[t] = !0);
  return i;
}
function Vr(e, i, r) {
  const t = Array.isArray(e);
  if (T(e) || t)
    for (const u in e)
      Array.isArray(e[u]) || T(e[u]) && !mr(e[u]) ? D(i) || Ve(r[u]) ? r[u] = Array.isArray(e[u]) ? be(e[u], []) : {
        ...be(e[u])
      } : Vr(e[u], B(i) ? {} : i[u], r[u]) : r[u] = !te(e[u], i[u]);
  return r;
}
var Ne = (e, i) => Vr(e, i, be(i)), br = (e, {
  valueAsNumber: i,
  valueAsDate: r,
  setValueAs: t
}) => D(e) ? e : i ? e === "" ? NaN : e && +e : r && Q(e) ? new Date(e) : t ? t(e) : e;
function Ie(e) {
  const i = e.ref;
  if (!(e.refs ? e.refs.every((r) => r.disabled) : i.disabled))
    return He(i) ? i.files : Ke(i) ? vr(e.refs).value : Ar(i) ? [...i.selectedOptions].map(({
      value: r
    }) => r) : ge(i) ? hr(e.refs).value : br(D(i.value) ? e.ref.value : i.value, e);
}
var Wr = (e, i, r, t) => {
  const u = {};
  for (const l of e) {
    const f = c(i, l);
    f && k(u, l, f._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: u,
    shouldUseNativeValidation: t
  };
}, ye = (e) => D(e) ? e : me(e) ? e.source : T(e) ? me(e.value) ? e.value.source : e.value : e, $r = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function ur(e, i, r) {
  const t = c(e, r);
  if (t || $e(r))
    return {
      error: t,
      name: r
    };
  const u = r.split(".");
  for (; u.length; ) {
    const l = u.join("."), f = c(i, l), A = c(e, l);
    if (f && !Array.isArray(f) && r !== l)
      return {
        name: r
      };
    if (A && A.type)
      return {
        name: l,
        error: A
      };
    u.pop();
  }
  return {
    name: r
  };
}
var Hr = (e, i, r, t, u) => u.isOnAll ? !1 : !r && u.isOnTouch ? !(i || e) : (r ? t.isOnBlur : u.isOnBlur) ? !e : (r ? t.isOnChange : u.isOnChange) ? e : !0, Kr = (e, i) => !le(c(e, i)).length && U(e, i);
const Gr = {
  mode: K.onSubmit,
  reValidateMode: K.onChange,
  shouldFocusError: !0
};
function zr(e = {}, i) {
  let r = {
    ...Gr,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: ee(r.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    errors: {}
  }, u = {}, l = T(r.defaultValues) || T(r.values) ? P(r.defaultValues || r.values) || {} : {}, f = r.shouldUnregister ? {} : P(l), A = {
    action: !1,
    mount: !1,
    watch: !1
  }, _ = {
    mount: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, S, E = 0;
  const F = {
    isDirty: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, v = {
    values: Me(),
    array: Me(),
    state: Me()
  }, j = e.resetOptions && e.resetOptions.keepDirtyValues, N = Pe(r.mode), oe = Pe(r.reValidateMode), se = r.criteriaMode === K.all, ce = (s) => (n) => {
    clearTimeout(E), E = setTimeout(s, n);
  }, V = async (s) => {
    if (F.isValid || s) {
      const n = r.resolver ? W((await M()).errors) : await X(u, !0);
      n !== t.isValid && v.state.next({
        isValid: n
      });
    }
  }, q = (s) => F.isValidating && v.state.next({
    isValidating: s
  }), G = (s, n = [], a, g, d = !0, o = !0) => {
    if (g && a) {
      if (A.action = !0, o && Array.isArray(c(u, s))) {
        const h = a(c(u, s), g.argA, g.argB);
        d && k(u, s, h);
      }
      if (o && Array.isArray(c(t.errors, s))) {
        const h = a(c(t.errors, s), g.argA, g.argB);
        d && k(t.errors, s, h), Kr(t.errors, s);
      }
      if (F.touchedFields && o && Array.isArray(c(t.touchedFields, s))) {
        const h = a(c(t.touchedFields, s), g.argA, g.argB);
        d && k(t.touchedFields, s, h);
      }
      F.dirtyFields && (t.dirtyFields = Ne(l, f)), v.state.next({
        name: s,
        isDirty: p(s, n),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      k(f, s, n);
  }, y = (s, n) => {
    k(t.errors, s, n), v.state.next({
      errors: t.errors
    });
  }, m = (s, n, a, g) => {
    const d = c(u, s);
    if (d) {
      const o = c(f, s, D(a) ? c(l, s) : a);
      D(o) || g && g.defaultChecked || n ? k(f, s, n ? o : Ie(d._f)) : H(s, o), A.mount && V();
    }
  }, x = (s, n, a, g, d) => {
    let o = !1, h = !1;
    const C = {
      name: s
    };
    if (!a || g) {
      F.isDirty && (h = t.isDirty, t.isDirty = C.isDirty = p(), o = h !== C.isDirty);
      const R = te(c(l, s), n);
      h = c(t.dirtyFields, s), R ? U(t.dirtyFields, s) : k(t.dirtyFields, s, !0), C.dirtyFields = t.dirtyFields, o = o || F.dirtyFields && h !== !R;
    }
    if (a) {
      const R = c(t.touchedFields, s);
      R || (k(t.touchedFields, s, a), C.touchedFields = t.touchedFields, o = o || F.touchedFields && R !== a);
    }
    return o && d && v.state.next(C), o ? C : {};
  }, L = (s, n, a, g) => {
    const d = c(t.errors, s), o = F.isValid && ae(n) && t.isValid !== n;
    if (e.delayError && a ? (S = ce(() => y(s, a)), S(e.delayError)) : (clearTimeout(E), S = null, a ? k(t.errors, s, a) : U(t.errors, s)), (a ? !te(d, a) : d) || !W(g) || o) {
      const h = {
        ...g,
        ...o && ae(n) ? {
          isValid: n
        } : {},
        errors: t.errors,
        name: s
      };
      t = {
        ...t,
        ...h
      }, v.state.next(h);
    }
    q(!1);
  }, M = async (s) => r.resolver(f, r.context, Wr(s || _.mount, u, r.criteriaMode, r.shouldUseNativeValidation)), z = async (s) => {
    const {
      errors: n
    } = await M();
    if (s)
      for (const a of s) {
        const g = c(n, a);
        g ? k(t.errors, a, g) : U(t.errors, a);
      }
    else
      t.errors = n;
    return n;
  }, X = async (s, n, a = {
    valid: !0
  }) => {
    for (const g in s) {
      const d = s[g];
      if (d) {
        const {
          _f: o,
          ...h
        } = d;
        if (o) {
          const C = _.array.has(o.name), R = await qe(d, f, se, r.shouldUseNativeValidation && !n, C);
          if (R[o.name] && (a.valid = !1, n))
            break;
          !n && (c(R, o.name) ? C ? _r(t.errors, R, o.name) : k(t.errors, o.name, R[o.name]) : U(t.errors, o.name));
        }
        h && await X(h, n, a);
      }
    }
    return a.valid;
  }, w = () => {
    for (const s of _.unMount) {
      const n = c(u, s);
      n && (n._f.refs ? n._f.refs.every((a) => !Be(a)) : !Be(n._f.ref)) && pe(s);
    }
    _.unMount = /* @__PURE__ */ new Set();
  }, p = (s, n) => (s && n && k(f, s, n), !te(Ge(), l)), O = (s, n, a) => yr(s, _, {
    ...A.mount ? f : D(n) ? l : Q(s) ? {
      [s]: n
    } : n
  }, a, n), I = (s) => le(c(A.mount ? f : l, s, e.shouldUnregister ? c(l, s, []) : [])), H = (s, n, a = {}) => {
    const g = c(u, s);
    let d = n;
    if (g) {
      const o = g._f;
      o && (!o.disabled && k(f, s, br(n, o)), d = Ae(o.ref) && B(n) ? "" : n, Ar(o.ref) ? [...o.ref.options].forEach((h) => h.selected = d.includes(h.value)) : o.refs ? ge(o.ref) ? o.refs.length > 1 ? o.refs.forEach((h) => (!h.defaultChecked || !h.disabled) && (h.checked = Array.isArray(d) ? !!d.find((C) => C === h.value) : d === h.value)) : o.refs[0] && (o.refs[0].checked = !!d) : o.refs.forEach((h) => h.checked = h.value === d) : He(o.ref) ? o.ref.value = "" : (o.ref.value = d, o.ref.type || v.values.next({
        name: s,
        values: {
          ...f
        }
      })));
    }
    (a.shouldDirty || a.shouldTouch) && x(s, d, a.shouldTouch, a.shouldDirty, !0), a.shouldValidate && de(s);
  }, J = (s, n, a) => {
    for (const g in n) {
      const d = n[g], o = `${s}.${g}`, h = c(u, o);
      (_.array.has(s) || !Ve(d) || h && !h._f) && !ne(d) ? J(o, d, a) : H(o, d, a);
    }
  }, re = (s, n, a = {}) => {
    const g = c(u, s), d = _.array.has(s), o = P(n);
    k(f, s, o), d ? (v.array.next({
      name: s,
      values: {
        ...f
      }
    }), (F.isDirty || F.dirtyFields) && a.shouldDirty && v.state.next({
      name: s,
      dirtyFields: Ne(l, f),
      isDirty: p(s, o)
    })) : g && !g._f && !B(o) ? J(s, o, a) : H(s, o, a), je(s, _) && v.state.next({
      ...t
    }), v.values.next({
      name: s,
      values: {
        ...f
      }
    }), !A.mount && i();
  }, fe = async (s) => {
    const n = s.target;
    let a = n.name, g = !0;
    const d = c(u, a), o = () => n.type ? Ie(d._f) : ar(s);
    if (d) {
      let h, C;
      const R = o(), ie = s.type === he.BLUR || s.type === he.FOCUS_OUT, Er = !$r(d._f) && !r.resolver && !c(t.errors, a) && !d._f.deps || Hr(ie, c(t.touchedFields, a), t.isSubmitted, oe, N), we = je(a, _, ie);
      k(f, a, R), ie ? (d._f.onBlur && d._f.onBlur(s), S && S(0)) : d._f.onChange && d._f.onChange(s);
      const ke = x(a, R, ie, !1), Cr = !W(ke) || we;
      if (!ie && v.values.next({
        name: a,
        type: s.type,
        values: {
          ...f
        }
      }), Er)
        return F.isValid && V(), Cr && v.state.next({
          name: a,
          ...we ? {} : ke
        });
      if (!ie && we && v.state.next({
        ...t
      }), q(!0), r.resolver) {
        const {
          errors: Ye
        } = await M([a]), Or = ur(t.errors, u, a), Ze = ur(Ye, u, Or.name || a);
        h = Ze.error, a = Ze.name, C = W(Ye);
      } else
        h = (await qe(d, f, se, r.shouldUseNativeValidation))[a], g = isNaN(R) || R === c(f, a, R), g && (h ? C = !1 : F.isValid && (C = await X(u, !0)));
      g && (d._f.deps && de(d._f.deps), L(a, C, h, ke));
    }
  }, de = async (s, n = {}) => {
    let a, g;
    const d = $(s);
    if (q(!0), r.resolver) {
      const o = await z(D(s) ? s : d);
      a = W(o), g = s ? !d.some((h) => c(o, h)) : a;
    } else
      s ? (g = (await Promise.all(d.map(async (o) => {
        const h = c(u, o);
        return await X(h && h._f ? {
          [o]: h
        } : h);
      }))).every(Boolean), !(!g && !t.isValid) && V()) : g = a = await X(u);
    return v.state.next({
      ...!Q(s) || F.isValid && a !== t.isValid ? {} : {
        name: s
      },
      ...r.resolver || !s ? {
        isValid: a
      } : {},
      errors: t.errors,
      isValidating: !1
    }), n.shouldFocus && !g && ve(u, (o) => o && c(t.errors, o), s ? d : _.mount), g;
  }, Ge = (s) => {
    const n = {
      ...l,
      ...A.mount ? f : {}
    };
    return D(s) ? n : Q(s) ? c(n, s) : s.map((a) => c(n, a));
  }, ze = (s, n) => ({
    invalid: !!c((n || t).errors, s),
    isDirty: !!c((n || t).dirtyFields, s),
    isTouched: !!c((n || t).touchedFields, s),
    error: c((n || t).errors, s)
  }), Fr = (s) => {
    s && $(s).forEach((n) => U(t.errors, n)), v.state.next({
      errors: s ? t.errors : {}
    });
  }, xr = (s, n, a) => {
    const g = (c(u, s, {
      _f: {}
    })._f || {}).ref;
    k(t.errors, s, {
      ...n,
      ref: g
    }), v.state.next({
      name: s,
      errors: t.errors,
      isValid: !1
    }), a && a.shouldFocus && g && g.focus && g.focus();
  }, pr = (s, n) => ee(s) ? v.values.subscribe({
    next: (a) => s(O(void 0, n), a)
  }) : O(s, n, !0), pe = (s, n = {}) => {
    for (const a of s ? $(s) : _.mount)
      _.mount.delete(a), _.array.delete(a), n.keepValue || (U(u, a), U(f, a)), !n.keepError && U(t.errors, a), !n.keepDirty && U(t.dirtyFields, a), !n.keepTouched && U(t.touchedFields, a), !r.shouldUnregister && !n.keepDefaultValue && U(l, a);
    v.values.next({
      values: {
        ...f
      }
    }), v.state.next({
      ...t,
      ...n.keepDirty ? {
        isDirty: p()
      } : {}
    }), !n.keepIsValid && V();
  }, Se = (s, n = {}) => {
    let a = c(u, s);
    const g = ae(n.disabled);
    return k(u, s, {
      ...a || {},
      _f: {
        ...a && a._f ? a._f : {
          ref: {
            name: s
          }
        },
        name: s,
        mount: !0,
        ...n
      }
    }), _.mount.add(s), a ? g && k(f, s, n.disabled ? void 0 : c(f, s, Ie(a._f))) : m(s, !0, n.value), {
      ...g ? {
        disabled: n.disabled
      } : {},
      ...r.shouldUseNativeValidation ? {
        required: !!n.required,
        min: ye(n.min),
        max: ye(n.max),
        minLength: ye(n.minLength),
        maxLength: ye(n.maxLength),
        pattern: ye(n.pattern)
      } : {},
      name: s,
      onChange: fe,
      onBlur: fe,
      ref: (d) => {
        if (d) {
          Se(s, n), a = c(u, s);
          const o = D(d.value) && d.querySelectorAll && d.querySelectorAll("input,select,textarea")[0] || d, h = qr(o), C = a._f.refs || [];
          if (h ? C.find((R) => R === o) : o === a._f.ref)
            return;
          k(u, s, {
            _f: {
              ...a._f,
              ...h ? {
                refs: [...C.filter(Be), o, ...Array.isArray(c(l, s)) ? [{}] : []],
                ref: {
                  type: o.type,
                  name: s
                }
              } : {
                ref: o
              }
            }
          }), m(s, !1, void 0, o);
        } else
          a = c(u, s, {}), a._f && (a._f.mount = !1), (r.shouldUnregister || n.shouldUnregister) && !(lr(_.array, s) && A.action) && _.unMount.add(s);
      }
    };
  }, Je = () => r.shouldFocusError && ve(u, (s) => s && c(t.errors, s), _.mount), Sr = (s, n) => async (a) => {
    a && (a.preventDefault && a.preventDefault(), a.persist && a.persist());
    let g = P(f);
    if (v.state.next({
      isSubmitting: !0
    }), r.resolver) {
      const {
        errors: d,
        values: o
      } = await M();
      t.errors = d, g = o;
    } else
      await X(u);
    U(t.errors, "root"), W(t.errors) ? (v.state.next({
      errors: {}
    }), await s(g, a)) : (n && await n({
      ...t.errors
    }, a), Je(), setTimeout(Je)), v.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: W(t.errors),
      submitCount: t.submitCount + 1,
      errors: t.errors
    });
  }, wr = (s, n = {}) => {
    c(u, s) && (D(n.defaultValue) ? re(s, c(l, s)) : (re(s, n.defaultValue), k(l, s, n.defaultValue)), n.keepTouched || U(t.touchedFields, s), n.keepDirty || (U(t.dirtyFields, s), t.isDirty = n.defaultValue ? p(s, c(l, s)) : p()), n.keepError || (U(t.errors, s), F.isValid && V()), v.state.next({
      ...t
    }));
  }, Qe = (s, n = {}) => {
    const a = s || l, g = P(a), d = s && !W(s) ? g : l;
    if (n.keepDefaultValues || (l = a), !n.keepValues) {
      if (n.keepDirtyValues || j)
        for (const o of _.mount)
          c(t.dirtyFields, o) ? k(d, o, c(f, o)) : re(o, c(d, o));
      else {
        if (We && D(s))
          for (const o of _.mount) {
            const h = c(u, o);
            if (h && h._f) {
              const C = Array.isArray(h._f.refs) ? h._f.refs[0] : h._f.ref;
              if (Ae(C)) {
                const R = C.closest("form");
                if (R) {
                  R.reset();
                  break;
                }
              }
            }
          }
        u = {};
      }
      f = e.shouldUnregister ? n.keepDefaultValues ? P(l) : {} : g, v.array.next({
        values: {
          ...d
        }
      }), v.values.next({
        values: {
          ...d
        }
      });
    }
    _ = {
      mount: /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, !A.mount && i(), A.mount = !F.isValid || !!n.keepIsValid, A.watch = !!e.shouldUnregister, v.state.next({
      submitCount: n.keepSubmitCount ? t.submitCount : 0,
      isDirty: n.keepDirty ? t.isDirty : !!(n.keepDefaultValues && !te(s, l)),
      isSubmitted: n.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: n.keepDirtyValues ? t.dirtyFields : n.keepDefaultValues && s ? Ne(l, s) : {},
      touchedFields: n.keepTouched ? t.touchedFields : {},
      errors: n.keepErrors ? t.errors : {},
      isSubmitting: !1,
      isSubmitSuccessful: !1
    });
  }, Xe = (s, n) => Qe(ee(s) ? s(f) : s, n), kr = (s, n = {}) => {
    const a = c(u, s), g = a && a._f;
    if (g) {
      const d = g.refs ? g.refs[0] : g.ref;
      d.focus && (d.focus(), n.shouldSelect && d.select());
    }
  }, Dr = (s) => {
    t = {
      ...t,
      ...s
    };
  };
  return ee(r.defaultValues) && r.defaultValues().then((s) => {
    Xe(s, r.resetOptions), v.state.next({
      isLoading: !1
    });
  }), {
    control: {
      register: Se,
      unregister: pe,
      getFieldState: ze,
      _executeSchema: M,
      _getWatch: O,
      _getDirty: p,
      _updateValid: V,
      _removeUnmounted: w,
      _updateFieldArray: G,
      _getFieldArray: I,
      _reset: Qe,
      _updateFormState: Dr,
      _subjects: v,
      _proxyFormState: F,
      get _fields() {
        return u;
      },
      get _formValues() {
        return f;
      },
      get _state() {
        return A;
      },
      set _state(s) {
        A = s;
      },
      get _defaultValues() {
        return l;
      },
      get _names() {
        return _;
      },
      set _names(s) {
        _ = s;
      },
      get _formState() {
        return t;
      },
      set _formState(s) {
        t = s;
      },
      get _options() {
        return r;
      },
      set _options(s) {
        r = {
          ...r,
          ...s
        };
      }
    },
    trigger: de,
    register: Se,
    handleSubmit: Sr,
    watch: pr,
    setValue: re,
    getValues: Ge,
    reset: Xe,
    resetField: wr,
    clearErrors: Fr,
    unregister: pe,
    setError: xr,
    setFocus: kr,
    getFieldState: ze
  };
}
function et(e = {}) {
  const i = b.useRef(), [r, t] = b.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ee(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    errors: {},
    defaultValues: ee(e.defaultValues) ? void 0 : e.defaultValues
  });
  i.current || (i.current = {
    ...zr(e, () => t((l) => ({
      ...l
    }))),
    formState: r
  });
  const u = i.current.control;
  return u._options = e, xe({
    subject: u._subjects.state,
    next: (l) => {
      fr(l, u._proxyFormState, u._updateFormState, !0) && t({
        ...u._formState
      });
    }
  }), b.useEffect(() => {
    e.values && !te(e.values, u._defaultValues) && u._reset(e.values, u._options.resetOptions);
  }, [e.values, u]), b.useEffect(() => {
    u._state.mount || (u._updateValid(), u._state.mount = !0), u._state.watch && (u._state.watch = !1, u._subjects.state.next({
      ...u._formState
    })), u._removeUnmounted();
  }), i.current.formState = cr(r, u), i.current;
}
export {
  Yr as Controller,
  Xr as FormProvider,
  Nr as appendErrors,
  c as get,
  k as set,
  Br as useController,
  Zr as useFieldArray,
  et as useForm,
  Fe as useFormContext,
  Ur as useFormState,
  Mr as useWatch
};
//# sourceMappingURL=index.esm.js.map
